import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { GetUnreadNotificationCountAsync } from '../../services/notification';
import { observer } from 'mobx-react';
import { store } from '../../stores/store';
import { ReactComponent as NotificationsUnreadIcon } from '../../assets/cg-notifications-unread.svg';

export const Actions = observer(() => {
  const navigate = useNavigate();
  const { notificationStore } = store;

  useEffect(() => {
    notificationStore.fetchUnreadCount();
  }, [notificationStore]);

  return (
    <div className={'header__actions'}>
      {/* <button className={'btn btn-flat'}>
        <span className={'material-symbols-outlined'}>search</span>
      </button> */}
      <button
        className={'btn btn-flat'}
        onClick={() => navigate(`?showtype=user-notifications`)}>
        {notificationStore.unreadCount > 0 ? (
          <NotificationsUnreadIcon width={24} height={24} />
        ) : (
          <span className={'material-symbols-outlined'}>notifications</span>
        )}
      </button>
    </div>
  );
});

export default Actions;
